import { render, staticRenderFns } from "./ServiceIncentivesTab.vue?vue&type=template&id=2a98285a&scoped=true&"
import script from "./ServiceIncentivesTab.vue?vue&type=script&lang=js&"
export * from "./ServiceIncentivesTab.vue?vue&type=script&lang=js&"
import style0 from "./ServiceIncentivesTab.vue?vue&type=style&index=0&id=2a98285a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a98285a",
  null
  
)

export default component.exports